<div *ngIf="nuevaSolicitud" class="modal request">
  <div class="modal__container" [formGroup]="this.solicitudForm">
    <div class="modal__header">
      <h2 class="modal__title">{{tituloSolicitud}}</h2>
      <a (click)="solicitud(false)" class="btn-close"><i class="material-icons">close</i></a>
    </div>
    <div class="modal__form" *ngIf="modalError">
      <p class="alert red">{{modalError}}</p>
    </div>
    <div *ngIf="paso2" class="modal__body">
      <div class="modal__form">
        <p *ngIf="error && !modalError" class="alert red">Ingrese datos obligatorios</p>
      </div>
      <div class="modal__form">
        <label for="">Cedula de identidad</label>
        <input formControlName="dni" appBlockCopyPaste maxlength="20" (keypress)="onlyNumber($event)" type="text">
      </div>
      <div class="modal__form">
        <label for="">Nombres (*)</label>
        <input formControlName="nombres" appBlockCopyPaste type="text" (keypress)="onlyLetter($event)">
      </div>
      <div class="modal__form">
        <label for="">Primer Apellido (*)</label>
        <input formControlName="apePaterno" appBlockCopyPaste type="text" (keypress)="onlyLetter($event)">
      </div>
      <div class="modal__form">
        <label for="">Segundo Apellido </label>
        <input formControlName="apeMaterno" appBlockCopyPaste type="text" (keypress)="onlyLetter($event)">
      </div>
      <div class="modal__form">
        <label for="">Correo Electrónico (*)</label>
        <input formControlName="email" appBlockCopyPaste type="email" maxlength="50">
      </div>
      <div class="modal__form">
        <label for="">Teléfono (*)</label>
        <input formControlName="tel" appBlockCopyPaste type="text" maxlength="20" (keypress)="onlyNumber($event)">
      </div>
      <div class="modal__form">
        <label for="">Número de Tarjeta (*)</label>
        <input formControlName="numTarjetExt" type="text">
      </div>
      <div class="modal__form">
        <label for="">Direccion (*)</label>
        <input formControlName="direccion" type="text">
      </div>
      <div class="modal__form">
        <label for="">Fecha Incidente (*) </label>
        <input formControlName="date" max="{{fechaAux | date:'yyyy-MM-dd'}}" type="date" onkeydown="return false">
      </div>
      <div class="modal__form">
        <label for="">Hora Incidente (*)</label>
        <input formControlName="hora" type="time">
      </div>


      <div class="modal__form">
        <label for="">Clasificación (*)</label>
        <select formControlName="clasif">
          <option value="-1">Selecciones una Clasificacion</option>
          <option *ngFor="let data of this.clasificaciones; let i = index" value="{{i}}">{{data.sDesLargo01}}
          </option>
        </select>
      </div>
      <div class="modal__form">
        <label for="">Subclasificación (*)</label>
        <select formControlName="subClasif">
          <option value="-1">Selecciones una subclasificacion</option>
          <option *ngFor="let data of this.subclasificacion;let i = index" value="{{i}}">{{data.sDesLargo01}}
          </option>
        </select>
      </div>
      <div class="modal__form">
        <label for="">Monto del saldo (*) </label>
        <input formControlName="monto" maxlength="7" type="text">
      </div>
      <div class="modal__form modal__message">
        <label for="">Descripción del problema (*)</label>
        <textarea formControlName="desc" maxlength="4000"></textarea>
      </div>
    </div>
    <div *ngIf="!paso2 && !soliciExito" class="modal__body">
      <div>
        <p class="request_option" (click)="confirmar(true)">Bloquear tarjeta
        </p>
      </div>
      <div>
     <!--   <p class="request_option" (click)="next(true, 'REPOS', 'Solicitud de Reposición de Tarjeta')">Enviar un
          reclamo</p> -->
      </div>
    </div>

    <div *ngIf="soliciExito" class="modal__body">
      <div class="modal__form">
        <label class="alert success">Solicitud enviada con éxito, con número <span style="font-weight: 600;">
            {{response.nNumSolicitud}}</span>
        </label>
      </div>
    </div>

    <div class="modal__footer">
      <button *ngIf="!soliciExito" class="btn btn-cancelar" (click)="solicitud(false)">Cancelar</button>
      <button *ngIf="soliciExito" class="btn btn-cancelar" (click)="solicitud(false)">Cerrar</button>
      <button *ngIf="paso2 && !loading " class="btn" (click)="sendSolicitud()">Enviar</button>
      <p *ngIf="modalError" class="alert red">{{modalError}}</p>
      <p class="alert red" *ngIf="errorSolicitud">Tarjeta tiene solicitudes en proceso, no se pueden realizar
        solicitudes.</p>
      <div *ngIf="paso2 && loading" class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

    </div>
  </div>
</div>
<div *ngIf="soliciExitoBlock" class="modal request">
  <div class="modal__container">
    <div class="modal__header">
      <h2 class="modal__title">Resultado</h2>
      <a (click)="confirmar(false)" class="btn-close"><i class="material-icons">close</i></a>
    </div>
    <div class="modal__body">
      <div class="modal__form">
        <label class="alert success">Solicitud de bloqueo enviada con éxito
        </label>
      </div>
    </div>
    <div class="modal__footer">
      <button class="btn-cancelar btn" (click)="soliciExitoBlock = false">Cerrar</button>
    </div>
  </div>
</div>

<div *ngIf="confirma" class="modal request">
  <div class="modal__container">
    <div class="modal__header">
      <h2 class="modal__title">¿Esta seguro de bloquear la tarjeta?</h2>
      <a (click)="cerrar()" class="btn-close"><i class="material-icons">close</i></a>
    </div>

    <div class="modal__body">
      <ng-container *ngIf="modalErrorBlock != ''; else form">

        <p class="alert red"> {{modalErrorBlock}}</p>
      </ng-container>
      <ng-template #form>
        <div class="modal__form modal__message">
          <label for="">Descripción del problema (*)</label>
          <textarea [(ngModel)]="descBloqueo" maxlength="50"></textarea>
          <label for="">{{descBloqueo.length}}/50</label>
        </div>
      </ng-template>

    </div>
    <div class="modal__footer">
      <button *ngIf="!loadingBlock" class="btn"
        (click)="next(true, 'BLOLN', 'Solicitud de Bloqueo de Tarjeta')">Bloquear</button>
      <div *ngIf="loadingBlock" class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <button class="btn-cancelar btn" (click)="confirmar(false)">Cancelar</button>
    </div>
  </div>
</div>